import { Spring } from "wobble";
export default function springUpdate(_ref) {
  var getOnUpdateFunc = _ref.getOnUpdateFunc,
      onAnimationEnd = _ref.onAnimationEnd,
      _ref$springConfig = _ref.springConfig,
      springConfig = _ref$springConfig === undefined ? {} : _ref$springConfig; // avoid potential passing in of variables that will cause a mistake
  // by destructuring to pass in only allowed vars

  var stiffness = springConfig.stiffness,
      damping = springConfig.damping,
      overshootClamping = springConfig.overshootClamping;
  var spring = new Spring({
    mass: 1,
    stiffness: stiffness,
    damping: damping,
    overshootClamping: overshootClamping
  });

  var stop = function stop() {
    return spring.stop();
  };

  var onUpdate = getOnUpdateFunc(stop);
  spring.onUpdate(onUpdate);
  spring.onStop(onAnimationEnd);
  spring.start();
  return spring;
}